export enum StandardHeadersMode {
  Default = 'default',
  Disable = 'disable',
}
